import React from 'react';
import PropTypes from 'prop-types';

import LoadingProgress from 'lib/react-router/loading-progress';
import FetchData from 'lib/fetch-data/fetch-data';

import { ThreadsTableViewModel } from 'four-nets/forum/threads-table/threads-table-view';
import ErrorPage from 'four-nets/errors/error-page';

import LatestTopicsView from './latest-topics-view';
import { CategoryStore } from '../forum';

class LatestTopicsLoader extends React.PureComponent {
    static contextTypes = {
        app: PropTypes.object,
        categoryStore: PropTypes.instanceOf(CategoryStore),
    };

    transform = data => {
        const { categoryStore } = this.context;

        const threads = categoryStore.threadStore.processPagedJSON({ json: data.threadsTableViewModel.threads });

        const threadsTableViewModel = new ThreadsTableViewModel();
        threadsTableViewModel.setThreads(threads);

        return {
            threadsTableViewModel,
        };
    };

    fetch = (setData, { page = 1 }) => {
        const { categoryStore } = this.context;

        return categoryStore.threadStore.loadMostRecent({ page, pager: 'paged_40' }).then(threads => {
            const threadsTableViewModel = new ThreadsTableViewModel();
            threadsTableViewModel.setThreads(threads);

            setData({
                threadsTableViewModel,
            });
        });
    };

    renderFetch = ({ loading, error, data }) => {
        return (
            <LoadingProgress loading={loading}>
                <ErrorPage error={error}>
                    <LatestTopicsView loading={loading} threadsTableViewModel={data?.threadsTableViewModel} />
                </ErrorPage>
            </LoadingProgress>
        );
    };

    render() {
        const { page } = this.props.search;

        return (
            <FetchData
                serializerKey={__filename}
                fetch={this.fetch}
                render={this.renderFetch}
                transform={this.transform}
                page={page}
            />
        );
    }
}

export default LatestTopicsLoader;
